import { useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { Checkbox } from "../ui/checkbox";
import { http } from "../../lib/api";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const submit = async (e) => {
    e.preventDefault();
    if (!consent) return toast.error("Please tick the consent box to subscribe.");
    setBusy(true);
    try {
      const r = await http.post("/newsletter", { email, consent, source: "homepage" });
      setDone(r.data.message);
    } catch (err) {
      toast.error(err.response?.data?.detail?.[0]?.msg || err.response?.data?.detail || "Something went wrong");
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="py-20 sm:py-28 bg-white" data-testid="newsletter-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="relative overflow-hidden rounded-[36px] ocean-gradient p-8 sm:p-14 grain">
          <Mail className="absolute -right-6 -top-6 w-48 h-48 text-white/10 rotate-12" />
          <p className="font-brush text-sun text-3xl">Postcards from paradise</p>
          <h2 className="mt-2 text-3xl sm:text-5xl font-extrabold text-white max-w-xl">Get vacation inspiration & new collections first</h2>
          {done ? (
            <p className="mt-8 rounded-2xl bg-white/15 text-white p-5 font-semibold" data-testid="newsletter-success">{done}</p>
          ) : (
            <form onSubmit={submit} className="mt-8 max-w-xl" data-testid="newsletter-form">
              <div className="flex flex-col sm:flex-row gap-3">
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" aria-label="Email address" className="w-full sm:flex-1 min-h-14 h-14 rounded-full px-6 text-navy outline-none focus:ring-4 focus:ring-sun/50" data-testid="newsletter-email-input" />
                <button disabled={busy} className="h-14 px-8 rounded-full bg-sun text-navy font-extrabold hover:bg-[#ffe34d] transition-colors disabled:opacity-60" data-testid="newsletter-submit-button">
                  {busy ? "Joining..." : "Join the crew"}
                </button>
              </div>
              <label className="mt-4 flex items-start gap-3 text-white/85 text-sm cursor-pointer">
                <Checkbox checked={consent} onCheckedChange={(v) => setConsent(!!v)} className="mt-0.5 border-white data-[state=checked]:bg-sun data-[state=checked]:text-navy" data-testid="newsletter-consent-checkbox" />
                <span>Yes, email me vacation inspiration, new collections and occasional promotions. Unsubscribe anytime. See our privacy policy.</span>
              </label>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};
